<template>
    <div class="threejsContainer">
      <div class="containerTitle">1-17.字母沿路径运动</div>
      <div ref="container" class="containerBody"></div>
    </div>
</template>
  
<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {FontLoader}    from 'three/examples/jsm/loaders/FontLoader.js';
import {TextGeometry}  from 'three/examples/jsm/geometries/TextGeometry.js';
import {Flow} from 'three/examples/jsm/modifiers/CurveModifier.js';
  
  export default {
    data() {
      return {
        scene: null,
        camera: null,
        renderer: null,
        controls: null,
        currentMesh: null,
        progress: 0,
        flow: null,
        u_time: 0,
        window: {
          width: 0,
          height: 0
        },
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      //创建网格对象
      this.createMesh();
      // 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize);
    },
    methods: {
      createMesh() {
        const initialPoints = [
					new THREE.Vector3(2, 1, -3),
          new THREE.Vector3(2, 0.5, 0),
          new THREE.Vector3(-2, 1, 2),
          new THREE.Vector3(0, 2, 3),
          new THREE.Vector3(2, 2, 2),
          new THREE.Vector3(-2, 1, -1),
          new THREE.Vector3(-2, 0, -4),
				];
        const curve = new THREE.CatmullRomCurve3(
          initialPoints,       // 控制点数组
          true,         // closed: 闭合曲线
          'centripetal',// curveType: 向心算法
          0.5           // tension: 中等张力
        );
        
        const points = curve.getPoints(1000);
				const line = new THREE.Line(
					new THREE.BufferGeometry().setFromPoints( points ),
					new THREE.LineBasicMaterial( { color: 0x00ff00 } )
				);

				this.scene.add( line );

        const fontLoader = new FontLoader();
        //字体文件放在项目的public目录下
        fontLoader.load("fonts/gentilis_bold.typeface.json",(font)=>{
          const str = 'Hello Xu Yi Fan! Hello Xu Yi Fan! Hello Xu Yi Fan!';
          const textGeometry = new TextGeometry( str, {
						font: font,
						size: 0.2,
						depth: 0.01,
						curveSegments: 12,
						bevelEnabled: true,
						bevelThickness: 0.02,
						bevelSize: 0.01,
						bevelOffset: 0,
						bevelSegments: 5,
					} );
					textGeometry.rotateX( Math.PI );
          
					const material = new THREE.MeshStandardMaterial( {
						color: 0x99ffff
					} );
          const cubeEdges = new THREE.Mesh(textGeometry, material);
          
					this.flow = new Flow( cubeEdges );
					this.flow.updateCurve( 0, curve );
					this.scene.add( this.flow.object3D );
        });
        this.animate();
      },
      animate() {
        this.animationId = requestAnimationFrame(this.animate);
        this.controls.update();
				if ( this.flow ) {
					this.flow.moveAlongCurve( -0.002 );
				}
        this.renderer.render(this.scene, this.camera);
      },
      initEnv(){
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化场景
        this.scene = generateScene();
        this.scene.background = new THREE.Color(0xffffff);
  
        // 初始化相机
        this.camera = genPerspectiveCamera(this.window);
  
        // 初始化渲染器
        this.renderer = genRenderer(this.window);
        this.$refs.container.appendChild(this.renderer.domElement);
  
        // 添加轨道控制器
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
  
        const gridHelper = new THREE.GridHelper(100, 100,
                                                0x666666,   // 中心轴线颜色（红色）
                                                0xcccccc    // 普通网格线颜色（绿色）
                                                ); // 10x10 网格
        this.scene.add(gridHelper);
      },
      onWindowResize() {
        const width = this.$refs.container.clientWidth;
        const height = this.$refs.container.clientHeight;
  
        // 更新相机
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
  
        // 更新渲染器
        this.renderer.setSize(width, height);
      }
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      // 释放资源
      if (this.currentMesh) {
        this.scene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }
      
      this.controls.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  };
  </script>
  
  <style>
  </style>
  